import React, {useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {getRouteMediasUrl, getRouteUrl, useRoute, useRouteMedias} from "../../hooks/useRoute";

const SaveRouteComponent = ({i18n, saveRoute, user, setStatus}) => {
    const url = getRouteUrl(saveRoute.type, i18n.language, saveRoute.route.slug);
    const { status, data: route } = useRoute(url, saveRoute.route.slug, user);
    const medialUrl = getRouteMediasUrl(saveRoute.type, i18n.language, saveRoute.route.slug, route);

    //alert('fix multipitch medias call (one per face), then updatestoreroute');
    const { status: statusMedias, fetchStatus: fetchStatusMedias, data: medias, error: errorMedias } = useRouteMedias(medialUrl, route, saveRoute.route.slug, user);

    useEffect(() => {
        if (setStatus !== undefined) {
            if (status !== "success" && data) {
                setStatus("success");
            } else {
                setStatus(status);
            }
        }
    }, [status]);

    return (<></>);
};

export default withTranslation()(SaveRouteComponent);